export default {
  'CHANGE_MAINTENANCES' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_MAINTENANCES' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/maintenances/mutations.js